(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Quick-add for collection product cards
  (function() {
    function injectQuickAdd(li) {
      if (li.querySelector('.fudge-qa-btn')) return;

      var card = li.querySelector('.product-card__content');
      if (!card) return;

      var handle = li.getAttribute('data-product-handle');

      var wrap = document.createElement('div');
      wrap.className = 'fudge-qa-wrap';

      // All Mintårta cakes use BSS/OPTIS custom options (size, filling, flavor)
      // that are not Shopify variants. has_only_default_variant is true even
      // for these products, so we always redirect to PDP for configuration.
      var link = document.createElement('a');
      link.className = 'fudge-qa-btn fudge-qa-btn--options';
      link.href = '/products/' + handle;
      link.textContent = 'Välj alternativ';
      wrap.appendChild(link);

      card.appendChild(wrap);
    }

    function injectAll() {
      var items = document.querySelectorAll('li.product-grid__item');
      for (var i = 0; i < items.length; i++) {
        injectQuickAdd(items[i]);
      }
    }

    function init() {
      injectAll();

      var grid = document.querySelector('.product-grid-container');
      if (grid && 'MutationObserver' in window) {
        var observer = new MutationObserver(function(mutations) {
          for (var i = 0; i < mutations.length; i++) {
            var nodes = mutations[i].addedNodes;
            for (var j = 0; j < nodes.length; j++) {
              if (nodes[j].nodeType === 1) {
                if (nodes[j].matches && nodes[j].matches('li.product-grid__item')) {
                  injectQuickAdd(nodes[j]);
                }
                var items = nodes[j].querySelectorAll && nodes[j].querySelectorAll('li.product-grid__item');
                if (items) {
                  for (var k = 0; k < items.length; k++) {
                    injectQuickAdd(items[k]);
                  }
                }
              }
            }
          }
        });
        observer.observe(grid, { childList: true, subtree: true });
      }

      // Load More button — replaces pagination with AJAX load
      initLoadMore();
    }

    function initLoadMore() {
      var pagination = document.querySelector('.pagination');
      if (!pagination) return;

      var grid = document.querySelector('.product-grid');
      if (!grid) return;

      // Find total product count from pagination
      var totalPages = parseInt(grid.getAttribute('data-last-page'), 10) || 1;
      if (totalPages <= 1) return; // No need for Load More if only one page

      var currentPage = 1;
      var totalProducts = 0;
      var visibleProducts = grid.querySelectorAll('li.product-grid__item').length;

      // Estimate total from pagination text
      var pageLinks = pagination.querySelectorAll('a');
      pageLinks.forEach(function(link) {
        var match = link.href.match(/page=(\d+)/);
        if (match) {
          var p = parseInt(match[1], 10);
          if (p > totalPages) totalPages = p;
        }
      });

      // Hide pagination
      pagination.style.display = 'none';

      // Create Load More container
      var loadMoreWrap = document.createElement('div');
      loadMoreWrap.className = 'fudge-load-more';
      loadMoreWrap.style.cssText = 'text-align:center; padding: 24px 0;';

      var progressText = document.createElement('p');
      progressText.className = 'fudge-load-more__progress';
      progressText.style.cssText = 'font-family: Inter, sans-serif; font-size: 14px; color: rgba(0,0,0,0.55); margin: 0 0 16px;';
      progressText.textContent = 'Visar ' + visibleProducts + ' artiklar';

      var loadBtn = document.createElement('button');
      loadBtn.className = 'fudge-load-more__btn';
      loadBtn.textContent = 'Visa fler';
      loadBtn.style.cssText = 'padding: 12px 32px; background: transparent; color: rgba(0,0,0,0.81); border: 1.5px solid rgba(0,0,0,0.15); border-radius: 14px; font-family: Inter, sans-serif; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s ease;';
      loadBtn.addEventListener('mouseenter', function() {
        loadBtn.style.borderColor = '#d4869a';
        loadBtn.style.color = '#d4869a';
      });
      loadBtn.addEventListener('mouseleave', function() {
        loadBtn.style.borderColor = 'rgba(0,0,0,0.15)';
        loadBtn.style.color = 'rgba(0,0,0,0.81)';
      });

      var loading = false;

      loadBtn.addEventListener('click', function() {
        if (loading || currentPage >= totalPages) return;
        loading = true;
        loadBtn.textContent = 'Laddar...';
        loadBtn.style.opacity = '0.6';

        var nextUrl = window.location.pathname + '?page=' + (currentPage + 1);
        fetch(nextUrl, { headers: { 'Accept': 'text/html' } })
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newItems = doc.querySelectorAll('li.product-grid__item');

            newItems.forEach(function(item) {
              grid.appendChild(item);
              if (typeof injectQuickAdd === 'function') injectQuickAdd(item);
            });

            visibleProducts = grid.querySelectorAll('li.product-grid__item').length;
            currentPage++;
            progressText.textContent = 'Visar ' + visibleProducts + ' artiklar';

            if (currentPage >= totalPages) {
              loadBtn.style.display = 'none';
              progressText.textContent = 'Visar alla ' + visibleProducts + ' artiklar';
            } else {
              loadBtn.textContent = 'Visa fler';
              loadBtn.style.opacity = '1';
            }
            loading = false;
          })
          .catch(function() {
            loadBtn.textContent = 'Visa fler';
            loadBtn.style.opacity = '1';
            loading = false;
          });
      });

      loadMoreWrap.appendChild(progressText);
      loadMoreWrap.appendChild(loadBtn);

      // Insert after the grid container
      var gridContainer = grid.closest('.product-grid-container') || grid.parentNode;
      if (gridContainer) {
        gridContainer.appendChild(loadMoreWrap);
      } else {
        grid.parentNode.appendChild(loadMoreWrap);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
